import debugLogger from "../utils/debugLogger";

import { EventHandler, EventSubscription } from "./EventTypes";
import { GlobalEventBus } from "./GlobalEventBus";

export class ModuleEventBus {
  private handlers: Map<string, EventHandler[]> = new Map();
  private subscriptions: Map<string, EventSubscription> = new Map();
  private moduleName: string;
  private globalBus: GlobalEventBus;

  constructor(moduleName: string, globalBus: GlobalEventBus) {
    this.moduleName = moduleName;
    this.globalBus = globalBus;
  }

  subscribe(event: string, handler: EventHandler): string {
    const id = this.generateId();
    const subscription: EventSubscription = {
      event,
      handler,
      id,
      module: this.moduleName,
    };
    if (!this.handlers.has(event)) {
      this.handlers.set(event, []);
    }
    this.handlers.get(event)!.push(handler);
    this.subscriptions.set(id, subscription);
    return id;
  }

  unsubscribe(id: string): boolean {
    const subscription = this.subscriptions.get(id);
    if (!subscription) return false;
    const handlers = this.handlers.get(subscription.event);
    if (handlers) {
      const index = handlers.indexOf(subscription.handler);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    }
    this.subscriptions.delete(id);
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(event: string, payload: any = {}): void {
    const handlers = this.handlers.get(event);
    if (handlers) {
      handlers.forEach((handler) => {
        try {
          handler(payload);
        } catch (error) {
          debugLogger.error(
            `[${this.moduleName}] Error in handler for event ${event}:`,
            error,
          );
        }
      });
    }
    this.globalBus.emit(`${this.moduleName}:${event}`, payload);
  }

  private generateId(): string {
    return `${this.moduleName}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
